import { useCallback, useEffect, useRef } from 'react'
import { BetHistoryButton } from './BetHistoryButton'
import { SoundButton } from './SoundButton'
import { LeaveGameButton } from './LeaveGameButton'
import { Container as PixiContainer } from 'pixi.js'
import { Container, Graphics } from '@pixi/react'
import {
  appScreen,
  Draw,
  FeatureToggleType, useFeatureToggleStore,
} from '@slot-nx/core'
import { RulesButton } from './RulesButton'
import { CloseButton } from './CloseButton'
import { MenuButton } from './MenuButton'
import { gameConfig } from '../../config'

import { menuUtil } from './menuUtil'
import { usePopupStore } from '../../domain/store/popupStore'
import { useSelector } from '@xstate/react'
import { GameState, sweetBombMachine } from '../../../machine/sweetbombMachine'

interface MenuProps {
  x: number
  y: number
  historyDisabled?: boolean
  speedBtnDisabled?: boolean
}

export const Menu = (props: MenuProps) => {
  const currentState = useSelector(sweetBombMachine, state => state)
  const featureToggle = useFeatureToggleStore(x => x.toggleList)
  const disableLeaveGameBtn = featureToggle.get(FeatureToggleType.disableLeaveGameBtn)
  const disableLeaveGameBtnByRedirectUrlNotExisted = featureToggle.get(
    FeatureToggleType.disableLeaveGameBtnByRedirectUrlNotExisted,
  )

  const shouldShowHistory = !featureToggle.get(FeatureToggleType.disableHistoryList)
  const shouldShowLeaveGame = !isDisableLeaveGameButton(
    disableLeaveGameBtn!,
    disableLeaveGameBtnByRedirectUrlNotExisted!,
  )

  const isOpenMenu = usePopupStore(x => x.isopenMenu)

  const drawBG = useCallback<Draw>((g) => {
    g.clear()
    g.beginFill('black', 1)
    g.drawRect(0, 0, gameConfig.resolution.width, 270)
    g.endFill()
  }, [])

  const drawLine = useCallback<Draw>((g) => {
    g.clear()
    g.beginFill('#FF74A8', 1)
    g.drawRect(0, 0, gameConfig.resolution.width, 2)
    g.endFill()
  }, [])

  const draw = useCallback<Draw>((graphics) => {
    graphics.clear()
    graphics.beginFill('white', 0.01)
    graphics.drawRect(0, 0, gameConfig.resolution.width, gameConfig.resolution.height)
    graphics.endFill()
  }, [])

  const iconSize = 120
  const iconY = (260 - iconSize) / 2
  const menuPanelRef = useRef<PixiContainer>()

  useEffect(() => {
    menuUtil.menuPanelRef = menuPanelRef.current as PixiContainer
  }, [])

  function openGameRules() {
    const iframe = document.getElementById('gameRulesIframe') as HTMLIFrameElement
    iframe.style.visibility = 'visible'
    iframe.style.pointerEvents = 'initial'
  }

  return (
    <Container name="Menu" position={[props.x, props.y]}>
      <MenuButton
        x={0}
        y={iconY - 50}
        width={iconSize}
        height={iconSize}
        enabled={currentState.matches(GameState.mainGame)}
        onPress={() => {
          usePopupStore.setState({ isopenMenu: true })
          menuUtil.menuPanelMove(-40, menuPanelRef.current as PixiContainer)
        }}
      />
      <Container
        name="Menu Panel"
        x={0}
        y={450}
        eventMode="static"
        ref={(el: PixiContainer | null) => {
          menuPanelRef.current = el as PixiContainer
        }}
      >
        {isOpenMenu
          ? (
              <Container name="menu hidden bg" x={0} y={-1630} width={appScreen.width} height={appScreen.height}>
                <Graphics
                  width={appScreen.width}
                  height={appScreen.height}
                  draw={draw}
                  eventMode="static"
                  ontap={() => {
                    menuUtil.menuPanelMove(500, menuPanelRef.current as PixiContainer)
                    usePopupStore.setState({ isopenMenu: false })
                  }}
                  onclick={() => {
                    menuUtil.menuPanelMove(500, menuPanelRef.current as PixiContainer)
                    usePopupStore.setState({ isopenMenu: false })
                  }}
                />
              </Container>
            )
          : null}

        <Graphics name="menu bg" draw={drawBG} />
        <Graphics name="line" width={gameConfig.resolution.width} height={2} draw={drawLine} />

        {shouldShowLeaveGame
          ? (
              <LeaveGameButton x={shouldShowHistory ? 820 : 640} y={iconY} width={iconSize} height={iconSize} />
            )
          : null}
        {shouldShowHistory
          ? (
              <BetHistoryButton disabled={props.historyDisabled} x={640} y={iconY} width={iconSize} height={iconSize} />
            )
          : null}

        <SoundButton x={460} y={iconY} width={iconSize} height={iconSize} />
        <RulesButton
          x={280}
          y={iconY}
          width={iconSize}
          height={iconSize}
        />

        <CloseButton
          x={100}
          y={iconY}
          width={iconSize}
          height={iconSize}
          onPress={() => {
            menuUtil.menuPanelMove(500, menuPanelRef.current as PixiContainer)
            usePopupStore.setState({ isopenMenu: false })
          }}
        />
      </Container>
      {/* </GrayBackground> */}
    </Container>
  )
}

export const isDisableLeaveGameButton = (
  disableLeaveGameBtn: boolean,
  disableLeaveGameBtnByRedirectUrlNotExisted: boolean,
) => {
  if (disableLeaveGameBtn) return true
  if (disableLeaveGameBtnByRedirectUrlNotExisted) {
    const url = window.sessionStorage.getItem('redirectUrl')
    return url === 'null' || url === null
  }
  return false
}
